import { removeProject } from '../../services/projects/ProjectService';
import React from 'react';
import { useAccount } from '../../contexts/account/AccountContexts';
import { showCustomDialog } from '../../helpers/DialogHelper';
import { t } from 'i18next';

const useRemoveProject = ({
  refreshProjects,
  setLoader,
}: {
  refreshProjects: () => void;
  setLoader?: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const { refetchData } = useAccount();

  const remove = async (id: number) => {
    if (setLoader) {
      setLoader(true);
    }

    try {
      await removeProject(id);

      refreshProjects();
      refetchData();
    } catch (error) {
      console.error('Error removing project:', error);
      refreshProjects();
    } finally {
      if (setLoader) {
        setLoader(false);
      }
    }
  };

  const confirmRemove = (id: number, name?: string) => {
    showCustomDialog({
      ...(name && { message: t('removeProjectConfirm', { name }) }),
      accept: () => remove(id),
    });
  };

  return { confirmRemove };
};

export default useRemoveProject;
